module.exports = __webpack_public_path__ + "static/media/12.e6641376.jpg";